export const ReceptionDrawerWidth = {
  fileMenu: '90px',
  fileArea: '330px',
  main: '390px',
  // fileMenu + main
  base: '480px',
  // fileMenu + fileArea + main
  expanded: '810px',
};
